import Ai from './ai'
import Simple from './simple'
import Router from './router'

export default {
    Ai,
    Simple,
    Router
}